export default __webpack_public_path__ + "static/skicka_faktura_print_tjanst-3602ccdbd502f116a58ddf12b993d66a.png";